import { render, staticRenderFns } from "./pay_detail_pass.vue?vue&type=template&id=56e25ee4"
import script from "./pay_detail_pass.vue?vue&type=script&lang=js"
export * from "./pay_detail_pass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports